import { UserAccountDetailsContextType } from './user-account-details-context.type';
import { createContext, ReactNode, useContext } from 'react';
import { useUserAccountDetails } from 'src/hooks/use-user-account-details';
import i18n from 'src/i18n';

const UserAccountDetailsContext = createContext<UserAccountDetailsContextType | undefined>(undefined);

export function UserAccountDetailsProvider({ children }: { children?: ReactNode }) {
  const accountDetails = useUserAccountDetails();

  return <UserAccountDetailsContext.Provider value={accountDetails}>{children}</UserAccountDetailsContext.Provider>;
}

export function useUserAccountDetailsContext() {
  const context = useContext(UserAccountDetailsContext);

  if (!context) {
    throw new Error(i18n.t('ERRORS.CONTEXT.USER_ACCOUNT_DETAILS'));
  }

  return context;
}
